export const CREATE_CASHOUT = 'CREATE_CASHOUT';
export const SUCCESS_CREATE_CASHOUT = 'SUCCESS_CREATE_CASHOUT';
export const FAILURE_CREATE_CASHOUT = 'FAILURE_CREATE_CASHOUT';

export const SET_CASHOUT_STATUS = 'SET_CASHOUT_STATUS';



// WEBPACK FOOTER //
// ./js/actions/Cashout.js